/**
 * Format a number as French currency
 * Uses comma for decimal separator and space for thousands separator
 */
export const formatFrenchCurrency = (amount: number): string => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

/**
 * Format a number as French decimal (without currency symbol)
 * Uses comma for decimal separator and space for thousands separator
 */
export const formatFrenchNumber = (amount: number): string => {
  return new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};
/**
 * Prix indicatif d'une offre au catalogue, tel qu'un prospect doit le lire.
 *
 * Une offre sans tarif de départ affichait « À partir de 0 € ». C'était le cas du
 * « Wedding Planning (clé en main) », l'offre mise en avant en tête du parcours de devis :
 * le visiteur lisait donc 0 € sur trois écrans d'affilée pour une prestation de mariage
 * complète. Ce n'est pas lu comme « gratuit », c'est lu comme un site en panne.
 *
 * Une prestation entièrement sur-mesure n'a pas de prix de départ, et c'est légitime : on
 * le DIT au lieu d'afficher un zéro. `CartSidebar` le faisait déjà de son côté avec sa
 * propre formule — d'où cette fonction, pour que les quatre écrans disent la même chose.
 */
export const formatPrixIndicatif = (montant: number | null | undefined): string => {
  const n = typeof montant === 'number' && isFinite(montant) ? montant : 0;
  return n > 0 ? `À partir de ${n.toLocaleString('fr-FR')} €` : 'Sur devis';
};
